import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function RaisedFist({...props}) {
  const {
    className,
    imageUrl,
    children,
    style
  } = props;
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "raised-fist.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 960) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <BackgroundImage 
    Tag="div"
    role="img"
    aria-label="A silhouetted woman with their fist raised against an orange sunset."
    className={className}
    fluid={imageData}
    style={style}
    >
      {children}
    </BackgroundImage>
  )
};

const styles = {
  width: "100%",
  backgroundPosition: "bottom center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
};

export default withStyles(styles)(RaisedFist);